module.exports = __webpack_public_path__ + "img/about-check.27fa85d1.svg";